import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import type { NavigateOptions } from 'react-router-dom';
import { useNavigationStackStore, buildStackEntry } from '../stores/navigationStackStore';

export function useAppNavigate() {
    const navigate = useNavigate();
    const location = useLocation();
    const push = useNavigationStackStore((state) => state.push);
    const clear = useNavigationStackStore((state) => state.clear);

    return useCallback((to: string, options?: NavigateOptions) => {
        if (!options?.replace) {
            const toPathname = to.split('?')[0];
            const currentFull = location.pathname + location.search;
            if (to !== currentFull) {
                if (toPathname === '/') {
                    clear();
                } else {
                    push(buildStackEntry(location.pathname, location.search, location.state as Record<string, unknown>));
                }
            }
        }
        void navigate(to, options);
    }, [navigate, location, push, clear]);
}
